import { render, staticRenderFns } from "./middleName.vue?vue&type=template&id=70c91c64&"
import script from "./middleName.vue?vue&type=script&lang=ts&"
export * from "./middleName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports